import React, { useEffect, useRef, useState } from 'react'
import {
  collection, addDoc, updateDoc, doc, getDocs,
  onSnapshot, orderBy, query, where, serverTimestamp, writeBatch
} from 'firebase/firestore'
import { db } from '../../firebase/firebase'
import AdminLayout from './AdminLayout'

const SEED_VERSES = [
  {
    reference: 'Ів. 3:16', referenceEn: 'John 3:16',
    text: 'Бо так возлюбив Бог світ, що дав Свого Сина Єдинородного, щоб кожен, хто вірує в Нього, не загинув, але мав вічне життя.',
    textEn: 'For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.',
  },
  {
    reference: 'Флп. 4:13', referenceEn: 'Phil. 4:13',
    text: 'Усе можу в Христі, що укріплює мене.',
    textEn: 'I can do all this through him who gives me strength.',
  },
  {
    reference: 'Єр. 29:11', referenceEn: 'Jer. 29:11',
    text: 'Бо Я знаю думки, що Я думаю про вас — говорить Господь — думки про мир, а не лихо, щоб дати вам майбутнє й надію.',
    textEn: '"For I know the plans I have for you," declares the Lord, "plans to prosper you and not to harm you, plans to give you hope and a future."',
  },
  {
    reference: 'Рим. 8:28', referenceEn: 'Rom. 8:28',
    text: 'А знаємо, що тим, хто любить Бога, хто покликаний за Його постановою, усе сприяє на добре.',
    textEn: 'And we know that in all things God works for the good of those who love him, who have been called according to his purpose.',
  },
  {
    reference: 'Мт. 11:28', referenceEn: 'Matt. 11:28',
    text: 'Прийдіть до Мене всі стомлені й обтяжені, і Я вас заспокою.',
    textEn: 'Come to me, all you who are weary and burdened, and I will give you rest.',
  },
  {
    reference: 'Пс. 23:1', referenceEn: 'Ps. 23:1',
    text: 'Господь — мій Пастир, — не матиму нестатку.',
    textEn: 'The Lord is my shepherd, I lack nothing.',
  },
  {
    reference: 'Іс. 40:31', referenceEn: 'Isa. 40:31',
    text: 'А хто надіється на Господа, сили поновить, орлиними крильми знімуться вгору, побіжать і не знесиляться, ходитимуть і не знеможуть.',
    textEn: 'But those who hope in the Lord will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.',
  },
  {
    reference: 'Ів. 14:6', referenceEn: 'John 14:6',
    text: 'Ісус відказав: Я — дорога, і правда, і життя; ніхто до Отця не прийде, як тільки через Мене.',
    textEn: 'Jesus answered, "I am the way and the truth and the life. No one comes to the Father except through me."',
  },
  {
    reference: 'Пс. 118:105', referenceEn: 'Ps. 119:105',
    text: 'Твоє слово — світильник моїй нозі й світло моїй стежці.',
    textEn: 'Your word is a lamp for my feet, a light on my path.',
  },
  {
    reference: 'Мт. 6:33', referenceEn: 'Matt. 6:33',
    text: 'Шукайте ж насамперед Царства Божого та правди Його, і це все вам додасться.',
    textEn: 'But seek first his kingdom and his righteousness, and all these things will be given to you as well.',
  },
  {
    reference: 'Гал. 6:9', referenceEn: 'Gal. 6:9',
    text: 'Доброго ж чинення не занедбаємо, бо в свій час пожнемо, якщо не ослабнемо.',
    textEn: 'Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.',
  },
  {
    reference: 'Пс. 27:1', referenceEn: 'Ps. 27:1',
    text: 'Господь — моя просвіта й спасіння моє, кого мені боятись? Господь — захист мого життя, кого мені жахатись?',
    textEn: 'The Lord is my light and my salvation — whom shall I fear? The Lord is the stronghold of my life — of whom shall I be afraid?',
  },
  {
    reference: '1 Кор. 13:13', referenceEn: '1 Cor. 13:13',
    text: 'А зараз залишаються: віра, надія, любов — ці три; та найбільша між ними — любов.',
    textEn: 'And now these three remain: faith, hope and love. But the greatest of these is love.',
  },
  {
    reference: 'Пс. 46:2', referenceEn: 'Ps. 46:1',
    text: 'Бог нам — захисток і сила, поміч у лихах завжди надійна.',
    textEn: 'God is our refuge and strength, an ever-present help in trouble.',
  },
  {
    reference: 'Ів. 10:10', referenceEn: 'John 10:10',
    text: 'Я прийшов, щоб мали вони життя, і мали вдосталь.',
    textEn: 'I have come that they may have life, and have it to the full.',
  },
  {
    reference: 'Мт. 28:20', referenceEn: 'Matt. 28:20',
    text: 'І ось Я з вами повсякчас аж до кінця світу.',
    textEn: 'And surely I am with you always, to the very end of the age.',
  },
  {
    reference: 'Як. 1:5', referenceEn: 'James 1:5',
    text: 'Коли хтось із вас мудрості потребує, нехай просить від Бога, що дає щедро всім і не докоряє.',
    textEn: 'If any of you lacks wisdom, you should ask God, who gives generously to all without finding fault, and it will be given to you.',
  },
  {
    reference: 'Єф. 6:10', referenceEn: 'Eph. 6:10',
    text: 'Нарешті, зміцнюйтеся в Господі та в міці сили Його.',
    textEn: 'Finally, be strong in the Lord and in his mighty power.',
  },
  {
    reference: '2 Тим. 1:7', referenceEn: '2 Tim. 1:7',
    text: 'Бо Бог нам дав не духа страху, а духа сили, і любови, і тверезого розуму.',
    textEn: 'For the Spirit God gave us does not make us timid, but gives us power, love and self-discipline.',
  },
  {
    reference: 'Пс. 34:9', referenceEn: 'Ps. 34:8',
    text: 'Скуштуйте й побачте, що добрий Господь; блаженна людина, що покладається на Нього!',
    textEn: 'Taste and see that the Lord is good; blessed is the one who takes refuge in him!',
  },
  {
    reference: 'Флп. 4:6', referenceEn: 'Phil. 4:6',
    text: 'Ні про що не турбуйтеся, але в усьому молитвою та благанням з подякою нехай будуть відомі Богові прохання ваші.',
    textEn: 'Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God.',
  },
  {
    reference: '1 Ів. 4:19', referenceEn: '1 John 4:19',
    text: 'Ми любимо Його, бо Він перший полюбив нас.',
    textEn: 'We love because he first loved us.',
  },
  {
    reference: 'Лк. 1:37', referenceEn: 'Luke 1:37',
    text: 'Бо в Бога неможливого нема.',
    textEn: 'For no word from God will ever fail.',
  },
  {
    reference: 'Нав. 1:9', referenceEn: 'Josh. 1:9',
    text: 'Чи ж Я не наказав тобі: Будь сильний та відважний? Не бійся й не лякайся, бо з тобою Господь, Бог твій, де б ти не ходив.',
    textEn: 'Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.',
  },
  {
    reference: 'Рим. 15:13', referenceEn: 'Rom. 15:13',
    text: 'А Бог надії нехай сповнить вас усякою радістю та миром у вірі, щоб ви збагатилися надією силою Духа Святого.',
    textEn: 'May the God of hope fill you with all joy and peace as you trust in him, so that you may overflow with hope by the power of the Holy Spirit.',
  },
  {
    reference: 'Пс. 37:5', referenceEn: 'Ps. 37:5',
    text: 'Довір Господеві дорогу свою, і покладися на Нього, — і Він учинить.',
    textEn: 'Commit your way to the Lord; trust in him and he will do this.',
  },
  {
    reference: 'Мт. 5:9', referenceEn: 'Matt. 5:9',
    text: 'Блаженні миротворці, бо їх синами Божими назвуть.',
    textEn: 'Blessed are the peacemakers, for they will be called children of God.',
  },
  {
    reference: 'Пс. 62:2', referenceEn: 'Ps. 62:1',
    text: 'Лише в Богові заспокоюється душа моя, бо від Нього спасіння моє.',
    textEn: 'Truly my soul finds rest in God; my salvation comes from him.',
  },
  {
    reference: 'Рим. 8:38-39', referenceEn: 'Rom. 8:38-39',
    text: 'Бо я переконаний, що ні смерть, ні життя, ні Ангели, ні Начала, ні сучасне, ні майбутнє, ні сили, ні висота, ні глибина, ні яке інше творіння не відлучить нас від Божої любові в Христі Ісусі, Господі нашому.',
    textEn: 'For I am convinced that neither death nor life, neither angels nor demons, neither the present nor the future, nor any powers, neither height nor depth, nor anything else in all creation, will be able to separate us from the love of God that is in Christ Jesus our Lord.',
  },
  {
    reference: 'Пс. 90:14', referenceEn: 'Ps. 91:14',
    text: 'За те, що він поклав надію на Мене, Я визволю його і захищу його, бо він знає ім\'я Моє.',
    textEn: '"Because he loves me," says the Lord, "I will rescue him; I will protect him, for he acknowledges my name."',
  },
]

const emptyForm = { reference: '', referenceEn: '', text: '', textEn: '' }

const AdminVerses = () => {
  const [verses, setVerses] = useState([])
  const [form, setForm] = useState(emptyForm)
  const [editId, setEditId] = useState(null)
  const [saving, setSaving] = useState(false)
  const [seeding, setSeeding] = useState(false)
  const [seedDone, setSeedDone] = useState(false)
  const [dupWarning, setDupWarning] = useState('')
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(new Set())
  const [bulkDeleting, setBulkDeleting] = useState(false)
  const selectAllRef = useRef(null)

  const filtered = (() => {
    const q = search.trim().toLowerCase()
    if (!q) return verses
    return verses.filter(v =>
      v.reference?.toLowerCase().includes(q) ||
      v.referenceEn?.toLowerCase().includes(q) ||
      v.text?.toLowerCase().includes(q) ||
      v.textEn?.toLowerCase().includes(q)
    )
  })()

  useEffect(() => { setDupWarning('') }, [form.reference])

  useEffect(() => {
    return onSnapshot(
      query(collection(db, 'verses'), orderBy('reference')),
      snap => {
        setVerses(snap.docs.map(d => ({ id: d.id, ...d.data() })))
        setSelected(new Set())
      }
    )
  }, [])

  useEffect(() => {
    if (!selectAllRef.current) return
    const allChecked = filtered.length > 0 && filtered.every(v => selected.has(v.id))
    const someChecked = filtered.some(v => selected.has(v.id)) && !allChecked
    selectAllRef.current.checked = allChecked
    selectAllRef.current.indeterminate = someChecked
  }, [selected, verses, search]) // eslint-disable-line react-hooks/exhaustive-deps

  const toggleOne = (id) => {
    setSelected(prev => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }

  const toggleAll = () => {
    if (selected.size === verses.length) {
      setSelected(new Set())
    } else {
      setSelected(new Set(verses.map(v => v.id)))
    }
  }

  const handleBulkDelete = async () => {
    const count = selected.size
    if (!window.confirm(`Видалити ${count} вірш${count === 1 ? '' : count < 5 ? 'і' : 'ів'}?`)) return
    setBulkDeleting(true)
    try {
      const batch = writeBatch(db)
      selected.forEach(id => batch.delete(doc(db, 'verses', id)))
      await batch.commit()
      setSelected(new Set())
    } catch (err) {
      alert('Помилка: ' + err.message)
    } finally {
      setBulkDeleting(false)
    }
  }

  const handleSave = async (e) => {
    e.preventDefault()
    const ref = form.reference.trim()
    if (!ref || !form.text.trim()) return
    setDupWarning('')
    setSaving(true)
    try {
      if (editId) {
        await updateDoc(doc(db, 'verses', editId), {
          reference:   ref,
          referenceEn: form.referenceEn.trim(),
          text:        form.text.trim(),
          textEn:      form.textEn.trim(),
        })
        setEditId(null)
      } else {
        const dup = await getDocs(query(collection(db, 'verses'), where('reference', '==', ref)))
        if (!dup.empty) { setDupWarning(`Вірш «${ref}» вже є в базі.`); return }
        await addDoc(collection(db, 'verses'), {
          reference:   ref,
          referenceEn: form.referenceEn.trim(),
          text:        form.text.trim(),
          textEn:      form.textEn.trim(),
          addedAt:     serverTimestamp(),
        })
      }
      setForm(emptyForm)
    } catch (err) {
      alert('Помилка: ' + err.message)
    } finally {
      setSaving(false)
    }
  }

  const handleEdit = (v) => {
    setEditId(v.id)
    setForm({ reference: v.reference || '', referenceEn: v.referenceEn || '', text: v.text || '', textEn: v.textEn || '' })
    setDupWarning('')
    window.scrollTo(0, 0)
  }

  const cancelEdit = () => { setEditId(null); setForm(emptyForm); setDupWarning('') }

  const handleSeed = async () => {
    const existing = new Set(verses.map(v => v.reference))
    const toAdd = SEED_VERSES.filter(v => !existing.has(v.reference))
    if (toAdd.length === 0) { alert('Усі вірші вже є в базі.'); return }
    const skipCount = SEED_VERSES.length - toAdd.length
    const msg = skipCount > 0
      ? `Додати ${toAdd.length} вірш${toAdd.length < 5 ? 'і' : 'ів'}? (${skipCount} дублікат${skipCount === 1 ? '' : 'ів'} буде пропущено)`
      : `Додати ${toAdd.length} підготовлених віршів?`
    if (!window.confirm(msg)) return
    setSeeding(true)
    try {
      const batch = writeBatch(db)
      toAdd.forEach(v => {
        batch.set(doc(collection(db, 'verses')), { ...v, addedAt: serverTimestamp() })
      })
      await batch.commit()
      setSeedDone(true)
    } catch (err) {
      alert('Помилка: ' + err.message)
    } finally {
      setSeeding(false)
    }
  }

  const f = (field, placeholder, required = false) => (
    <div style={s.field}>
      <label style={s.label}>{placeholder}</label>
      <input
        value={form[field]}
        onChange={e => setForm(p => ({ ...p, [field]: e.target.value }))}
        style={s.input}
        placeholder={placeholder}
        required={required}
      />
    </div>
  )

  return (
    <AdminLayout>
      <div style={s.page}>
        <div style={s.pageHeader}>
          <div>
            <h1 style={s.pageTitle}>Вірші дня</h1>
            <p style={s.pageDesc}>{verses.length} віршів · показуються випадково на головній · UA (Огієнко) + EN (NIV)</p>
          </div>
          <div style={s.headerActions}>
            {selected.size > 0 && (
              <button onClick={handleBulkDelete} disabled={bulkDeleting} style={s.btnDanger}>
                {bulkDeleting ? 'Видалення…' : `🗑 Видалити (${selected.size})`}
              </button>
            )}
            {seedDone && <span style={s.seedDone}>✓ Готово</span>}
          </div>
        </div>

        <div style={s.cols}>
          {/* Form */}
          <div style={s.card}>
            <div style={s.cardHeader}>
              <span style={s.cardIcon}>{editId ? '✏️' : '✝'}</span>
              <span style={s.cardTitle}>{editId ? 'Редагувати вірш' : 'Новий вірш'}</span>
              {editId && <button onClick={cancelEdit} style={s.btnCancel}>✕</button>}
            </div>
            <form onSubmit={handleSave} style={s.form}>
              <div style={s.langSection}>
                <div style={s.langLabel}>🇺🇦 Українська (Огієнко)</div>
                {f('reference', 'Посилання укр., напр. Ів. 3:16', true)}
                <div style={s.field}>
                  <label style={s.label}>Текст укр.</label>
                  <textarea
                    value={form.text}
                    onChange={e => setForm(p => ({ ...p, text: e.target.value }))}
                    style={{ ...s.input, height: '80px', resize: 'vertical' }}
                    placeholder='Текст вірша українською…'
                    required
                  />
                </div>
              </div>
              <div style={s.langSection}>
                <div style={s.langLabel}>🇬🇧 English (NIV)</div>
                {f('referenceEn', 'Reference EN, e.g. John 3:16')}
                <div style={s.field}>
                  <label style={s.label}>Text EN</label>
                  <textarea
                    value={form.textEn}
                    onChange={e => setForm(p => ({ ...p, textEn: e.target.value }))}
                    style={{ ...s.input, height: '80px', resize: 'vertical' }}
                    placeholder='Verse text in English…'
                  />
                </div>
              </div>
              {dupWarning && <div style={s.dupWarn}>⚠️ {dupWarning}</div>}
              <button type='submit' disabled={saving} style={s.btnPrimary}>
                {saving ? 'Збереження…' : editId ? '💾 Зберегти зміни' : 'Додати вірш'}
              </button>
            </form>
          </div>

          {/* List */}
          <div style={s.card}>
            <div style={s.cardHeader}>
              <span style={s.cardIcon}>📖</span>
              <span style={s.cardTitle}>Усі вірші</span>
              <span style={s.badge}>{search.trim() ? `${filtered.length} / ${verses.length}` : verses.length}</span>
            </div>

            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ ...s.input, marginBottom: '12px' }}
              placeholder='🔍 Пошук по вірші або тексту…'
            />

            {verses.length === 0 ? (
              <div style={s.empty}>Немає віршів. Додайте вручну або натисніть «Додати готових».</div>
            ) : filtered.length === 0 ? (
              <div style={s.empty}>Нічого не знайдено.</div>
            ) : (
              <>
                <div style={s.selectAllRow}>
                  <label style={s.checkLabel}>
                    <input
                      ref={selectAllRef}
                      type='checkbox'
                      onChange={toggleAll}
                      style={s.checkbox}
                    />
                    <span style={s.selectAllText}>
                      {selected.size === 0 ? 'Виділити всі' : `Виділено: ${selected.size}`}
                    </span>
                  </label>
                </div>

                <div style={s.list}>
                  {filtered.map(v => (
                    <div
                      key={v.id}
                      style={{ ...s.row, ...(selected.has(v.id) ? s.rowSelected : {}) }}
                      onClick={() => toggleOne(v.id)}
                    >
                      <input
                        type='checkbox'
                        checked={selected.has(v.id)}
                        onChange={() => toggleOne(v.id)}
                        onClick={e => e.stopPropagation()}
                        style={s.checkbox}
                      />
                      <div style={s.rowContent}>
                        <div style={s.rowRefs}>
                          <span style={s.rowRef}>{v.reference}</span>
                          {v.referenceEn && <span style={s.rowRefEn}>{v.referenceEn}</span>}
                        </div>
                        <div style={s.rowText}>{v.text}</div>
                        {v.textEn && <div style={s.rowTextEn}>{v.textEn}</div>}
                      </div>
                      <button
                        onClick={e => { e.stopPropagation(); handleEdit(v) }}
                        style={s.btnEditRow}
                        title='Редагувати'
                      >✏️</button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}

const s = {
  page: { maxWidth: '1100px' },
  pageHeader: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '28px', flexWrap: 'wrap' },
  pageTitle: { margin: '0 0 4px', fontSize: '24px', fontWeight: '700', color: '#2d1f14' },
  pageDesc: { margin: 0, fontSize: '13px', color: '#9a7c63' },
  headerActions: { display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginLeft: 'auto' },
  seedDone: { fontSize: '13px', color: '#3a8a3a' },

  cols: { display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '24px', alignItems: 'start' },

  card: {
    background: '#fff', borderRadius: '14px', padding: '24px',
    boxShadow: '0 2px 16px rgba(92,61,46,0.07)', border: '1px solid #f0e4d4',
  },
  cardHeader: {
    display: 'flex', alignItems: 'center', gap: '10px',
    marginBottom: '20px', paddingBottom: '14px', borderBottom: '1px solid #f5ede3',
  },
  cardIcon: { fontSize: '16px' },
  cardTitle: { fontSize: '15px', fontWeight: '700', color: '#2d1f14', flex: 1 },
  badge: {
    background: '#f0e6d8', color: '#8b6044',
    padding: '2px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
  },

  form: { width: '100%', margin: 0, border: 'none', background: 'none', padding: 0, display: 'block' },
  langSection: {
    background: '#fdfaf7', borderRadius: '8px', padding: '12px 14px',
    border: '1px solid #f0e4d4', marginBottom: '14px',
  },
  langLabel: { fontSize: '12px', fontWeight: '700', color: '#8b6044', marginBottom: '10px' },
  field: { marginBottom: '10px' },
  label: {
    display: 'block', fontSize: '10px', fontWeight: '700',
    letterSpacing: '0.5px', textTransform: 'uppercase', color: '#9a7c63', marginBottom: '5px',
  },
  input: {
    width: '100%', padding: '9px 12px',
    border: '1.5px solid #e8d8c8', borderRadius: '7px',
    fontSize: '13px', color: '#2d1f14', background: '#fff',
    boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none',
  },

  btnPrimary: {
    padding: '10px 22px', background: 'linear-gradient(135deg, #6b4a32, #8b6044)',
    color: '#fff', border: 'none', borderRadius: '8px',
    fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit',
  },
  btnSeed: {
    padding: '9px 18px', background: 'transparent', color: '#8b6044',
    border: '1.5px solid #c4986a', borderRadius: '8px',
    fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0,
  },
  btnDanger: {
    padding: '9px 18px', background: '#c0392b', color: '#fff',
    border: 'none', borderRadius: '8px',
    fontSize: '13px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0,
  },
  dupWarn: {
    background: '#fff8e6', border: '1px solid #f0c040', color: '#7a5c00',
    borderRadius: '8px', padding: '10px 14px', fontSize: '13px', marginBottom: '10px',
  },
  btnCancel: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px',
    color: '#9a7c63', padding: '2px 6px',
  },
  btnEditRow: {
    background: '#f0e4d4', border: 'none', borderRadius: '6px',
    padding: '5px 8px', cursor: 'pointer', fontSize: '13px', flexShrink: 0,
  },

  selectAllRow: {
    padding: '8px 14px 10px',
    borderBottom: '1px solid #f5ede3',
    marginBottom: '10px',
  },
  checkLabel: {
    display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none',
  },
  checkbox: {
    width: '15px', height: '15px', cursor: 'pointer', accentColor: '#8b6044', flexShrink: 0,
  },
  selectAllText: { fontSize: '12px', color: '#8b6044', fontWeight: '600' },

  empty: { color: '#b8a090', fontSize: '14px', padding: '12px 0', textAlign: 'center' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '620px', overflowY: 'auto' },
  row: {
    display: 'flex', alignItems: 'flex-start', gap: '10px',
    padding: '12px 14px', borderRadius: '10px',
    background: '#fdfaf7', border: '1.5px solid #f0e4d4',
    cursor: 'pointer',
  },
  rowSelected: {
    background: '#fdf4ec', border: '1.5px solid #c4986a',
  },
  rowContent: { flex: 1, minWidth: 0 },
  rowRefs: { display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '5px', flexWrap: 'wrap' },
  rowRef: { fontSize: '12px', fontWeight: '700', color: '#c4986a' },
  rowRefEn: { fontSize: '11px', fontWeight: '600', color: '#b8a090' },
  rowText: { fontSize: '13px', color: '#2d1f14', lineHeight: '1.5', marginBottom: '4px' },
  rowTextEn: { fontSize: '12px', color: '#7a6050', lineHeight: '1.4', fontStyle: 'italic' },
}

export default AdminVerses
